import React from 'react';

import { Space } from 'antd';

import EmailEditorFontSetting from './EmailEditorFontSetting';

const EmailEditorSigningOffSettings = () => {
  return (
    <Space direction='horizontal' size={0}>
      <EmailEditorFontSetting />
    </Space>
  );
};

export default EmailEditorSigningOffSettings;
